import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Home from './react/components/Home'
import Header from './react/components/Header'
import Login from './react/components/Login'
import Register from './react/components/Register'
import Programmers from './react/components/Programmers'
import Dashboard from './react/components/Dashboard'
import MobileHeader from './react/components/MobileHeader'
import People from './react/components/People'
import _404 from './react/components/_404'
import SuccessMessages from './react/components/SuccessMessages'
import ErrorMessages from './react/components/ErrorMessages'
import withAuth from './react/components/withAuth'
import Footer from './react/components/Footer'


function App() {
  return (
    <>
      <Header />
      <MobileHeader />
      <SuccessMessages />
      <ErrorMessages />

      <Switch>
        <Route path='/' exact component={Home} />
        <Route path='/programmers' exact component={Programmers} />
        <Route path='/people' exact component={People} />
        <Route path='/dashboard' exact component={withAuth(Dashboard)} />
        <Route path='/login' exact component={Login} />
        <Route path='/register' exact component={Register} />
        <Route path='*' exact component={_404} />
      </Switch>

      <Footer />
    </>
  )
}

export default App
